import React, { useEffect } from 'react'
import { CheckIcon, XIcon, WarningIcon, IdeaIcon } from './Icons'
import '../styles/Toast.css'

const Toast = ({ id, message, type = 'info', duration = 3000, onClose }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose(id)
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [id, duration, onClose])

  const icons = {
    success: <CheckIcon size={16} />,
    error: <XIcon size={16} />,
    warning: <WarningIcon size={16} />,
    info: <IdeaIcon size={16} />
  }

  return (
    <div className={`toast toast-${type}`} role="alert" aria-live="polite">
      <div className="toast-icon">{icons[type]}</div>
      <div className="toast-message">{message}</div>
      <button
        className="toast-close"
        onClick={() => onClose(id)}
        aria-label="Close notification"
      >
        <XIcon size={14} />
      </button>
    </div>
  )
}

export default Toast
